export default {
  padding: 10
};
